<template>
  <v-row>
    <v-col cols="12" sm="6" md="3">
      <h3>{{ $t('auto.labels.kasko') }}</h3>
      <v-select
        :items="propertyItems"
        v-model="credentials.kasko"
        item-text="title"
        item-value="id"
        class="ma-2"
      />

      <div class="ma-2">
        <menu-datepicker
          :label="$t('common.fields.expiry') + ' *'"
          :disabled="credentials.kasko === 0"
          :rules="rules.expiryKasko"
          :value="credentials.expiryKasko"
          no-max
          @change="credentials.expiryKasko = $event"
        />
      </div>
      <v-text-field
        :disabled="credentials.kasko === 0"
        v-model="credentials.kaskoName"
        :label="$t('auto.labels.kaskoName') + ' *'"
        :rules="rules.kaskoName"
        type="text"
        class="ma-2"
        autocomplete="off"
      />
      <v-btn
        color="warning"
        elevation="0"
        outlined
        block
        @click="
          () => {
            filesDialog.opened = true;
            filesDialog.type = 'kasko';
            filesDialog.files = credentials.kaskoFiles;
          }
        "
      >
        {{ $t('common.docs') }}
        <template
          v-if="credentials.kaskoFiles && credentials.kaskoFiles.length"
        >
          ({{ credentials.kaskoFiles.length }})
        </template>
      </v-btn>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <h3>{{ $t('auto.labels.osgpo') }}</h3>
      <v-select
        :items="propertyItems"
        v-model="credentials.osgpo"
        item-text="title"
        item-value="id"
        class="ma-2"
      />
      <div class="ma-2">
        <menu-datepicker
          :label="$t('common.fields.expiry') + ' *'"
          :disabled="credentials.osgpo === 0"
          :rules="rules.expiryOsgpo"
          :value="credentials.expiryOsgpo"
          no-max
          @change="credentials.expiryOsgpo = $event"
        />
      </div>
      <v-text-field
        :disabled="credentials.osgpo === 0"
        v-model="credentials.osgpoName"
        :label="$t('auto.labels.osgpoName') + ' *'"
        :rules="rules.osgpoName"
        type="text"
        class="ma-2"
        autocomplete="off"
      />
      <v-btn
        color="warning"
        elevation="0"
        outlined
        block
        @click="
          () => {
            filesDialog.opened = true;
            filesDialog.type = 'osgpo';
            filesDialog.files = credentials.osgpoFiles;
          }
        "
      >
        {{ $t('common.docs') }}
        <template
          v-if="credentials.osgpoFiles && credentials.osgpoFiles.length"
        >
          ({{ credentials.osgpoFiles.length }})
        </template>
      </v-btn>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <h3>{{ $t('auto.labels.tax') }}</h3>
      <v-select
        :items="propertyItems"
        v-model="credentials.tax"
        item-text="title"
        item-value="id"
        class="ma-2"
      />
      <div class="ma-2">
        <menu-datepicker
          :label="$t('common.fields.expiry') + ' *'"
          :disabled="credentials.tax === 0"
          :rules="rules.expiryTax"
          :value="credentials.expiryTax"
          no-max
          @click="credentials.expiryTax = $event"
        />
      </div>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <h3>{{ $t('auto.labels.checkup') }}</h3>
      <div class="ma-2">
        <menu-datepicker
          :label="$t('common.fields.openCheckup') + ' *'"
          :rules="rules.openCheckup"
          no-max
          :value="credentials.openCheckup"
          @change="credentials.openCheckup = $event"
        />
      </div>
      <div class="ma-2">
        <menu-datepicker
          :label="$t('common.fields.closeCheckup') + ' *'"
          :rules="rules.closeCheckup"
          :value="credentials.closeCheckup"
          no-max
          @change="credentials.closeCheckup = $event"
        />
      </div>
    </v-col>

    <insurance-files-dialog
      v-model="filesDialog.opened"
      :type="filesDialog.type"
      :auto-id="$route.params.autoId"
      :files="filesDialog.files"
      :read-only="isInvestor"
      :no-download="!$can('auto_files_download') && !isInvestor"
      :no-delete="!$can('auto_files_delete') || isInvestor"
      only-files
      @save="onFilesSave"
      @delete="onFileDelete"
    />
  </v-row>
</template>

<script>
import { mask } from 'vue-the-mask';
import DateHelper from '@/helpers/dateHelper';
import MenuDatepicker from '@/components//shared/MenuDatepicker.vue';
import InsuranceFilesDialog from '@/components/auto/InsuranceFilesDialog.vue';

export default {
  name: 'Dates',
  directives: {
    mask,
  },
  components: {
    MenuDatepicker,
    InsuranceFilesDialog,
  },
  props: {
    dates: Object,
  },
  data() {
    return {
      credentials: {
        kasko: 1,
        expiryKasko: null,
        osgpo: 1,
        expiryOsgpo: null,
        kaskoName: '',
        osgpoName: '',
        kaskoFiles: [],
        osgpoFiles: [],
        tax: 1,
        expiryTax: null,
        openCheckup: null,
        closeCheckup: null,
      },
      filesDialog: {
        opened: false,
        type: '',
        files: [],
      },
      rules: {
        /* eslint-disable */
        expiryKasko: [
          (v) =>
            this.credentials.kasko === 0 ||
            !!v ||
            this.$t('common.fields.validation.field.required'),
          (v) =>
            this.credentials.kasko === 0 ||
            new Date() < DateHelper.getDateObj(v) ||
            this.$t('common.fields.validation.expiredDate'),
        ],
        kaskoName: [
          (v) =>
            this.credentials.kasko === 0 ||
            !!v ||
            this.$t('common.fields.validation.field.required'),
        ],
        expiryOsgpo: [
          (v) =>
            this.credentials.osgpo === 0 ||
            !!v ||
            this.$t('common.fields.validation.field.required'),
          (v) =>
            this.credentials.osgpo === 0 ||
            new Date() < DateHelper.getDateObj(v) ||
            this.$t('common.fields.validation.expiredDate'),
        ],
        osgpoName: [
          (v) =>
            this.credentials.osgpo === 0 ||
            !!v ||
            this.$t('common.fields.validation.field.required'),
        ],
        expiryTax: [
          (v) =>
            this.credentials.tax === 0 ||
            !!v ||
            this.$t('common.fields.validation.field.required'),
          (v) =>
            this.credentials.tax === 0 ||
            new Date() < DateHelper.getDateObj(v) ||
            this.$t('common.fields.validation.expiredDate'),
        ],
        openCheckup: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) =>
            new Date() > DateHelper.getDateObj(v) ||
            this.$t('auto.fields.validation.futureCheckup'),
        ],
        closeCheckup: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) =>
            DateHelper.getDateObj(this.credentials.openCheckup) <
              DateHelper.getDateObj(v) ||
            this.$t('auto.fields.validation.badCloseCheckup'),
        ],
        /* eslint-enable */
      },
      dateFields: [
        'expiryKasko',
        'expiryOsgpo',
        'expiryTax',
        'openCheckup',
        'closeCheckup',
      ],
    };
  },
  watch: {
    'credentials.kasko': {
      handler(val) {
        if (val === 0) {
          this.credentials.expiryKasko = '';
          this.credentials.kaskoName = '';
        }
      },
    },
    'credentials.osgpo': {
      handler(val) {
        if (val === 0) {
          this.credentials.expiryOsgpo = '';
          this.credentials.osgpoName = '';
        }
      },
    },
    'credentials.tax': {
      handler(val) {
        if (val === 0) {
          this.credentials.expiryTax = '';
        }
      },
    },
  },
  computed: {
    propertyItems() {
      return [
        {
          id: 0,
          title: this.$t('common.fields.noItem'),
        },
        {
          id: 1,
          title: this.$t('common.fields.yesItem'),
        },
      ];
    },
    isInvestor() {
      return this.$store.getters['global/getRole'] === 'investor';
    },
  },
  methods: {
    getComponentData() {
      this.$emit('update:dates', this.credentials);
    },
    writeDataToFields(data) {
      this.credentials = data;
    },
    onFilesSave(data) {
      const insuranceParams = Object.keys(data).reduce((res, key) => {
        if (Array.isArray(data[key])) {
          const lastFiles = this.credentials[key] || [];
          res[key] = [...lastFiles, ...data[key]]; // eslint-disable-line
        } else {
          res[key] = data[key]; // eslint-disable-line
        }

        return res;
      }, {});

      this.credentials = { ...this.credentials, ...insuranceParams };
    },
    onFileDelete({ filesName, id }) {
      const updatedList = this.credentials[filesName].filter(
        (file) => file.id !== id,
      );

      this.filesDialog.files = updatedList;
      this.credentials[filesName] = updatedList;
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-weight: 300;
}
</style>
